(function ($) {
    'use strict';

    /**
     * Боковая панель на страницах ТОТО
     * @returns {jQuery}
     */
    $.fn.totoPanel = function () {
        const $panel = $(this);
        const $btn = $('.js-toto-panel-btn');

        /**
         * Открыть панель
         */
        const open = function () {
            $('html').css('overflow', 'hidden');
            $panel.addClass('open');
        };

        /**
         * Закрыть панель
         */
        const close = function () {
            $('html').css('overflow', '');
            $panel.removeClass('open');
        };

        /**
         * Позиционирование текста на переключателе панели
         */
        const btnTextPosition = function() {
            const $btnText = $('.js-toto-panel-btn-text');
            const btnRect = $btnText.parent().get(0).getBoundingClientRect();
            const topMargin = window.innerHeight / 2 - ($btnText.width() / 2);
            const bottomMargin = window.innerHeight / 2 + ($btnText.width() / 2);

            if (
                btnRect.top <= topMargin &&
                btnRect.bottom >= bottomMargin
            ) {
                $btnText.addClass('fixed');
                $btnText.removeClass('bottom');
            } else {
                $btnText.removeClass('fixed');

                if (btnRect.bottom < bottomMargin) {
                    $btnText.addClass('bottom');
                }
            }
        }

        /**
         * Инициализация
         */
        const init = function () {
            // Клик по переключателю панели
            $btn.on('click', function () {
                if ($panel.hasClass('open')) {
                    close();
                } else {
                    open();
                }
            });

            // Клик по фону панели
            $panel.on('click', function (e) {
                if ($panel.is(e.target)) {
                    close();
                }
            });

            // Корректировка позиция текста при переключении вкладки
            $(window).on('tabchange', function () {
                $(window).trigger('scroll');
                btnTextPosition();
            });

            // Закрытие панели при ресайзе окна
            $(window).on('resize', function () {
                close();
            });

            // Позиционирование текста на переключателе панели
            $(window).on('scroll resize load', btnTextPosition);
            btnTextPosition();

        };

        init();

        this.open = open;
        this.close = close;
        this.btnTextPosition = btnTextPosition;

        return this;
    };
})(jQuery);
